
import { ProfileForm } from "../../ProfileForm";
import { PasswordChangeForm } from "../PasswordChangeForm";
import { GymCodeForm } from "../GymCodeForm";
import { CompleteProfileModal } from "../CompleteProfileModal";
import { EmailChangeInfo } from "../EmailChangeInfo";
import { Profile } from "@/hooks/profile/types";

interface ProfileTabContentProps {
  profile: Profile;
  showPasswordChange: boolean;
  onProfileUpdate: (updates: Partial<Profile>) => Promise<void>;
  onLogout: () => Promise<void>;
  onNavigate: (path: string) => void;
}

export const ProfileTabContent = ({
  profile,
  showPasswordChange,
  onProfileUpdate,
  onLogout,
  onNavigate
}: ProfileTabContentProps) => {
  return (
    <div className="space-y-8">
      <CompleteProfileModal profile={profile} onComplete={onProfileUpdate} />
      
      <EmailChangeInfo />
      
      <div className="gym-section">
        <GymCodeForm />
      </div>
      
      {showPasswordChange ? (
        <div className="password-section">
          <PasswordChangeForm onCancel={() => onNavigate("/configuracion")} />
        </div>
      ) : (
        <div className="profile-section">
          <ProfileForm 
            profile={profile}
            onUpdate={onProfileUpdate}
            onLogout={onLogout}
          />
        </div>
      )}
    </div>
  );
};
